import { render, staticRenderFns } from "./TrackFeedback2.vue?vue&type=template&id=8c4709cc&scoped=true"
import script from "./TrackFeedback2.vue?vue&type=script&lang=js"
export * from "./TrackFeedback2.vue?vue&type=script&lang=js"
import style0 from "./TrackFeedback2.vue?vue&type=style&index=0&id=8c4709cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4709cc",
  null
  
)

export default component.exports